module.exports = {
	activityXP: {
		title: 'កាដូរមហាសាលសម្រាប់សមាជិកថ្មី',
		h1: 'ថ្នាលជួញដូរ',
		h2: 'កាដូរសម្រាប់សមាជិកថ្មីរងចាំអ្នក',
		activityTime: 'កាលបរិច្ឆេទនៃព្រឹត្តិការណ៍៖ 2025/06/06 ~ 2025/08/31',
		activityRule: 'លក្ខខណ្ឌក្នុងការចូលរួម',
		activityRuleDetail: 'ក្នុងអំឡុងព្រឹត្តិការណ៍នេះ អ្នកប្រើប្រាស់ដែលចុះឈ្មោះ និងបំពេញការផ្ទៀងផ្ទាត់អត្តសញ្ញាណ ហើយចំនួនទឹកប្រាក់ប្រតិបត្តិការកើនឡើងដល់ 100 ដុល្លារអាមេរិក (រួមបញ្ចូល) ឬច្រើនជាងនេះ នឹងមានសិទ្ធិចូលរួមដោយស្វ័យប្រវត្តិក្នុងការបែងចែករង្វាន់សរុប ៣០ ម៉ឺនដុល្លារអាមេរិក',
		exchangeRule: 'លក្ខខណ្ឌនៃការប្ដូរយករង្វាន់',
		exchangeRuleDetail: 'ចំនួនប្រាក់រង្វាន់ដែលទទួលបានដោយអ្នកប្រើប្រាស់នឹងត្រូវបានបែងចែកដោយផ្អែកលើចំនួនទឹកប្រាក់ជួញដូរផ្ទាល់ខ្លួនក្នុងអំឡុងពេលព្រឹត្តិការណ៍នេះ ទៅនឹងចំនួនទឹកប្រាក់ជួញដូរសរុបនៃការជួញដូរ',
		exchangeType: 'របៀបប្តូរយករង្វាន់',
		exchangeTypeDetail: 'ប្រាក់រង្វាន់នឹងត្រូវបានចែកដោយស្វ័យប្រវត្តិទៅកាន់គណនីរបស់អ្នកប្រើប្រាស់នៅចន្លោះកាលបរិច្ឆេទ 01/09/2025 និង 07/09/2025 ។',
	},
	common: {
		load: 'Loading~',
		xp_network: 'ការស្នើសុំបណ្តាញលើសពេលវេលាកំណត់ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ',
	},
}